import { createAsyncThunk } from "@reduxjs/toolkit";
import { END_USERS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getEndUserListAPI: any = createAsyncThunk(
  "getEndUserList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(END_USERS, {
        // headers: {
        //   // istoken: "false",
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
        params: params,
      });
      return { users: res };
    } catch (error: any) {
      console.log(error, "reading error");
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
